import { render, staticRenderFns } from "./DisabledForm.vue?vue&type=template&id=9f03797e&"
import script from "./DisabledForm.vue?vue&type=script&lang=js&"
export * from "./DisabledForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports